import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Shift } from 'src/app/models/shift.model';
import { ShiftService } from 'src/app/Services/shift.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteShiftDialogComponent } from 'src/app/components/delete-shift-dialog/delete-shift-dialog.component';

@Component({
    selector: 'app-shift-management',
    templateUrl: './shift-management.component.html',
    styleUrls: ['./shift-management.component.css'],
    standalone: false
})
export class ShiftManagementComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  @ViewChild(MatSort) sort: MatSort;
  
  @Input() shifts: Shift[] = [];
  @Input() isLoading = false;
  @Input() shiftLimitReached = false;
  
  @Output() refreshShifts = new EventEmitter<number>();
  @Output() editShiftEvent = new EventEmitter<Shift>();
  
  isSubmitting = false;
  
  
  constructor(
    private shiftService: ShiftService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    // Shift data is now provided by parent component via @Input()
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  
  editShiftClicked(shift: Shift): void {
    this.editShiftEvent.emit(shift);
  }

  deleteShiftClicked(shift: Shift): void {
    const dialogRef = this.dialog.open(DeleteShiftDialogComponent, {
      width: '400px',
      data: { shift: shift },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.refreshShifts.emit(shift.id);
      }
    });
  }

  getDayName(dayNumber: number): string {
    const days = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    return days[dayNumber] || '';
  }

  getDayLetter(dayNumber: number): string {
    const letters = ['', 'M', 'T', 'W', 'T', 'F', 'S', 'S'];
    return letters[dayNumber] || '';
  }

  sortData(event: any): void {
    // Sorting logic can be implemented here if needed
    // For now, the table will use default Material sorting
  }

}
